import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { SecondaryButton } from "../../Buttons/SecondaryButton";
import { ThemedButton } from "../../Buttons/ThemedButton";
import { Card } from "../../shadcn/card";

import bg from "./bg.png";

export const ContactCard = ({
  variant = "faqOnly",
  className,
  cardTitle,
  cardDescription,
  faqButtonText,
  onFaqClick,
  chatButtonText,
  onChatClick,
  align = "center",
}: {
  variant?: "faqOnly" | "withChat";
  className?: string;
  cardTitle?: string;
  cardDescription?: string;
  faqButtonText?: string;
  onFaqClick?: () => void;
  chatButtonText?: string;
  onChatClick?: () => void;
  align?: "center" | "left";
}) => {
  const handleFaqClick = () => {
    onFaqClick?.();
  };

  return (
    <Card
      className={cnTwMerge(
        "bg-background/primary p-6 relative overflow-hidden",
        className,
      )}
      noShadow
    >
      <div className="absolute inset-0 flex justify-center items-center z-0 pointer-events-none">
        <div className="w-full h-full flex justify-center items-start">
          <img className=" w-[388px] h-[73px]" src={bg} />
        </div>
      </div>

      <div
        className={cnTwMerge("flex flex-col relative z-10 text-center", {
          "items-center": align === "center",
          "items-start": align === "left",
        })}
      >
        <p
          className={cnTwMerge(
            "body-large-semibold mb-2 max-w-[280px] leading-6",
            {
              "text-center": align === "center",
              "text-left": align === "left",
            },
          )}
        >
          {cardTitle ?? m.help_haveAnyQuestions()}
        </p>
        <p
          className={cnTwMerge("body-base-regular text-text/secondary", {
            "text-center": align === "center",
            "text-left": align === "left",
          })}
        >
          {variant === "withChat"
            ? m.help_contactUsForAnyFurthe()
            : cardDescription || m.help_findAnswersToCommonQu()}
        </p>

        <div className="mt-6 space-y-4 flex flex-col items-center xl:w-full">
          <SecondaryButton dataTestId="faqs" onClick={handleFaqClick}>
            {faqButtonText ?? m.help_seeFaqs()}
          </SecondaryButton>
          {variant === "withChat" && (
            <ThemedButton
              dataTestId="chat"
              fullWidth
              onClick={onChatClick}
              variant="primary"
            >
              {chatButtonText ?? m.contactUs_secondaryAction()}
            </ThemedButton>
          )}
        </div>
      </div>
    </Card>
  );
};
